import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { TabsBox, StyledTabs, StyledTab } from './styles';

function MobileTabs({ labels, contents, setMobileChosenTab, defaultChosenTab = 0 }) {
  const history = useHistory();
  const location = useLocation();
  const [value, setValue] = useState(defaultChosenTab);

  const handleChange = (event, newValue) => {
    history.push({
      pathname: location.pathname,
      search: 'page=1'
    });
    setValue(newValue);
    if (setMobileChosenTab) {
      setMobileChosenTab(newValue);
    }
  };

  const tabsWithContents = labels
    .map((label, index) => ({ label, content: contents[index] }))
    .filter(pair => pair.content);

  useEffect(() => {
    if (value >= tabsWithContents.length) {
      setValue(0);
    }
  }, [value, tabsWithContents.length]);

  return (
    <TabsBox>
      <StyledTabs
        value={value}
        onChange={handleChange}
        aria-label="Custom tabs"
      >
        {tabsWithContents.map((tab, index) => (
          <StyledTab
            key={index}
            className={`${index === 0 ? 'outer' : ''} ${index === tabsWithContents.length - 1 ? 'inner' : ''}`}
            label={tab.label}
            onClick={() => handleChange(null, index)}
          />
        ))}
      </StyledTabs>
      <div>
        {tabsWithContents[value]?.content}
      </div>
    </TabsBox>
  );
}

export default MobileTabs;
